module.exports = __webpack_public_path__ + "static/media/open.25eec225.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/open.PNG
// module id = 1428
// module chunks = 0